/**
 * Courier list + tracking URL builder for the pharmacy dispensing console.
 *
 * Mirrors the production pharmacy portal delivery-method picker (DHL, FedEx,
 * Evri, Pharmacy Xpress, UPS, Parcelforce, DPD) plus Royal Mail for UK
 * post. `trackingUrlFor` matches the carrier-specific URLs orders-service
 * uses when emailing the patient.
 */

/** Closed delivery-method list — the wording the dispensary already uses. */
export const PHARMACY_COURIERS = [
  'DHL',
  'FedEx',
  'Evri',
  'Pharmacy Xpress',
  'UPS',
  'Parcelforce',
  'DPD',
  'Royal Mail',
] as const;

export type PharmacyCourier = (typeof PHARMACY_COURIERS)[number];

/** Build a public carrier tracking URL when the courier is recognised. */
export function trackingUrlFor(courier: string, trackingNumber: string): string | null {
  const c = courier.toLowerCase();
  const n = encodeURIComponent(trackingNumber.trim());
  if (!n) return null;
  if (c.includes('dhl')) return `https://www.dhl.com/gb-en/home/tracking.html?tracking-id=${n}`;
  if (c.includes('fedex')) return `https://www.fedex.com/fedextrack/?trknbr=${n}`;
  if (c.includes('evri') || c.includes('hermes')) return `https://www.evri.com/track/parcel/${n}`;
  if (c.includes('ups')) return `https://www.ups.com/track?tracknum=${n}`;
  if (c.includes('parcelforce')) return `https://www.parcelforce.com/track-trace?trackNumber=${n}`;
  if (c.includes('dpd')) return `https://www.dpd.co.uk/track?parcel=${n}`;
  if (c.includes('royal mail')) return `https://www.royalmail.com/track-your-item#/tracking-results/${n}`;
  return null;
}
